const slideshowBlock = document.querySelectorAll('.field-slideshow');

if(slideshowBlock && slideshowBlock.length > 0) {
  slideshowBlock.forEach(function(slideshow) {
    let navigation = slideshow.querySelector('.slider-navigation');
    let isDown = false; // Tracks if the mouse button is pressed
    let startX;         // Stores the initial X-coordinate of the mouse
    let startY;         // Stores the initial Y-coordinate of the mouse
    let scrollLeft;     // Stores the initial scrollLeft of the container
    let scrollTop;      // Stores the initial scrollTop of the container

    if(navigation) {
      navigation.addEventListener('mousedown', (e) => {
        isDown = true;
        startX = e.pageX - navigation.offsetLeft;
        startY = e.pageY - navigation.offsetTop;
        scrollLeft = navigation.scrollLeft;
        scrollTop = navigation.scrollTop;
      });

      navigation.addEventListener('mouseup', () => {
          isDown = false;
      });

      navigation.addEventListener('mouseleave', () => {
          isDown = false;
      });

      navigation.addEventListener('mousemove', (e) => {
          if (!isDown) return; // Stop the function from running when not dragging
          e.preventDefault(); // Prevent default browser drag behavior

          const x = e.pageX - navigation.offsetLeft;
          const y = e.pageY - navigation.offsetTop;
          const walkX = (x - startX) * 2;
          const walkY = (y - startY) * 2;

          navigation.scrollLeft = scrollLeft - walkX;
          navigation.scrollTop = scrollTop - walkY;
      });
    }
  });
}